export interface Step {
    interval: number;
    iterations: number;
}

export interface PollHandler {
    (): boolean | Promise<boolean>;
}

export default function createPoller(
    pollHandler: PollHandler,
    steps: Step[],
): Promise<undefined> {
    let count = 0;
    let stepNumber = 0;
    async function poll(): Promise<any> {
        count += 1;
        const currentStep = steps[stepNumber];
        if (currentStep) {
            try {
                const donePolling = await pollHandler();
                if (!donePolling) {
                    if (count >= currentStep.iterations) {
                        stepNumber += 1;
                        count = 0;
                    }
                    await new Promise((r) =>
                        setTimeout(r, currentStep.interval),
                    );
                    return await poll();
                }
            } catch (error) {
                throw Error("Error in poller");
            }
        }
        return undefined;
    }

    return poll();
}
